// extracted by mini-css-extract-plugin
module.exports = {"info__bar":"Transaction_info__bar__UeXm3","logo__main":"Transaction_logo__main__l09le"};